import React from 'react';

import { Button } from '@lightspeed/unified-components-default-consumer-theme/react';
import { T } from '@transifex/react';
import { useFormContext } from 'react-hook-form';

import { DateAndGuestsSection } from '../../../reservation/components/reservation-form/timeslot-step/date-and-guests-section';
import { TimeslotSection } from '../../../reservation/components/reservation-form/timeslot-step/timeslot-section';
import type { ReservationFormData } from '../../../reservation/types';
import { BusinessLocation } from '../../../shared/types';

import { StickyFooter } from './sticky-footer';

interface TimeslotStepProps {
  businessLocation: BusinessLocation;
  onNext: () => void;
}

export function TimeslotStep({ businessLocation, onNext }: TimeslotStepProps) {
  const { watch } = useFormContext<ReservationFormData>();
  const utcScheduledAt = watch('utcScheduledAt');

  return (
    <>
      <div className="px-4 py-3">
        <DateAndGuestsSection businessLocation={businessLocation} />
        <TimeslotSection businessLocation={businessLocation} />
      </div>

      <StickyFooter>
        <Button
          type="button"
          size="large"
          block
          disabled={!utcScheduledAt}
          onClick={onNext}
          customDataAttributes={{ root: { testid: 'reservation-next-button' } }}
        >
          <T
            _str="Continue to contact details"
            _context="Continue to next reservation step button"
            _tags="widget,reservation"
            _key="Widget.ReservationForm.Next.button"
          />
        </Button>
      </StickyFooter>
    </>
  );
}
